import Checkbox from "@/v2-ui/checkbox"
import Label from "@/v2-ui/label"
import CountryFlag from "@/v2-backoffice-client/country/CountryFlag"

export type FeatureCountryOptionProps = {
  code: number
  alpha2: string
  name?: string | null
  isChecked: boolean
  /** Withheld here by an explicit exclusion; the checkbox cannot override it. */
  isExcluded: boolean
  disabled?: boolean
  onCheckedChange(isChecked: boolean): void
}

/**
 * One country's row in the availability list. Owns nothing — the tab holds
 * the draft — so re-rendering the list on a toggle stays cheap.
 */
function FeatureCountryOption(props: FeatureCountryOptionProps) {
  const {
    code,
    alpha2,
    name,
    isChecked,
    isExcluded,
    disabled,
    onCheckedChange,
  } = props

  const id = `feature-country-${code}`

  return (
    <span className="flex items-center gap-2">
      <Checkbox
        id={id}
        checked={isChecked}
        disabled={disabled || isExcluded}
        onCheckedChange={(checked) => onCheckedChange(checked === true)}
      />
      <Label
        htmlFor={id}
        className="flex min-w-0 flex-1 cursor-pointer items-center gap-2 text-xs font-normal"
      >
        <CountryFlag alpha2={alpha2} name={name} />
        <span className="truncate">{name ?? alpha2}</span>
      </Label>
      {isExcluded && (
        <span
          className="shrink-0 text-[11px] text-muted-foreground"
          title="An explicit exclusion withholds this feature here. Exclusions are authored deliberately, so this list does not clear them."
        >
          Excluded
        </span>
      )}
    </span>
  )
}

export default FeatureCountryOption
